import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorHistory = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M18.25 8.75V11a.75.75 0 1 0 1.5 0V8a.75.75 0 0 0-.236-.546l-5.306-5a.75.75 0 0 0-.515-.204H6.5A2.75 2.75 0 0 0 3.75 5v14a2.75 2.75 0 0 0 2.75 2.75h5a.75.75 0 0 0 0-1.5h-5c-.69 0-1.25-.56-1.25-1.25V5c0-.69.56-1.25 1.25-1.25h6.443V6a2.75 2.75 0 0 0 2.75 2.75h2.557Zm-1.14-1.5h-1.417c-.69 0-1.25-.56-1.25-1.25V4.737L17.11 7.25Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M8 7.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5H8Zm0 4a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5H8Zm9 2.5a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5ZM12.25 17a4.75 4.75 0 1 1 9.5 0 4.75 4.75 0 0 1-9.5 0Zm5.5-2a.75.75 0 0 0-1.5 0v2c0 .414.336.75.75.75h2a.75.75 0 0 0 0-1.5h-1.25V15Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorHistory;
